import { komisiModul_get_all_cabang_reducers } from "../reducers/KomisiAllCabangReducers";
import { komisiModul_get_cabang_reducers } from "../reducers/KomisiCabangReducers";

const modulKomisi = {
  komisiModul_get_all_cabang: komisiModul_get_all_cabang_reducers,
  komisiModul_get_cabang: komisiModul_get_cabang_reducers,
};

export default modulKomisi;
